import classes from '../../components/DepartmentsTree/DepartmentsTreeNode/DepartmentsTreeNode.module.scss';

export const getEmployeeFioItemWithMatch = (fio, searchMatch) => {
    let employeeFioItem
    if (searchMatch !== '' && fio.toUpperCase().includes(searchMatch.toUpperCase())) {
        const parts = fio.split(new RegExp(`(${searchMatch})`, 'gi'))
        employeeFioItem = parts.map((part, index) => part.toUpperCase() === searchMatch.toUpperCase() ? <span key={index} className={classes.matchStr}>{part}</span> : part)
    } else employeeFioItem = fio
    return employeeFioItem
}